import { render, staticRenderFns } from "./ServicePoint.vue?vue&type=template&id=7cdee0c8&scoped=true"
import script from "./ServicePoint.vue?vue&type=script&lang=js"
export * from "./ServicePoint.vue?vue&type=script&lang=js"
import style0 from "./ServicePoint.vue?vue&type=style&index=0&id=7cdee0c8&prod&lang=less&scoped=true"
import style1 from "./ServicePoint.vue?vue&type=style&index=1&id=7cdee0c8&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdee0c8",
  null
  
)

export default component.exports